var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aboutus-giontsujiri-modal-container" }, [
    _c(
      "div",
      {
        staticClass: "aboutus-giontsujiri-modal-overlay",
        attrs: { "aria-hidden": _vm.showModalId ? "false" : "true" },
        on: { click: _vm.hideModal }
      },
      [
        _vm._l(_vm.items, function(item) {
          return [
            _c(
              "Modal",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showModalId === item.id,
                    expression: "showModalId === item.id"
                  }
                ],
                key: item.id,
                on: { close: _vm.hideModal }
              },
              [
                _c("template", { slot: "image" }, [
                  _c("img", { attrs: { src: item.img, alt: "" } })
                ])
              ],
              2
            )
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "itemlist" },
      _vm._l(_vm.items, function(item) {
        return _c("li", { key: item.id }, [
          _c(
            "a",
            {
              attrs: { href: item.img, "data-id": item.id },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.showModal(item.id)
                }
              }
            },
            [_c("img", { attrs: { src: item.thumb, alt: "" } })]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }